function manipulateElement(element) {
  element.innerHTML = element.innerHTML.replace(/®/g, '');
}

function startObserver() {
  var targetSelectors = '.cart-item__name, .vorteil-text, .product-subtext, .steckt-drin-small-headline, .page-content p, .ph-subheadline, .track123_order_info_detail_title, .content-text-second, .phasen-text, .benefit-amount, .fussnote-page.fussnote-index, h2.collapsible-content__heading.inline-richtext, h4.phasen-headline, em.R-TextBody.R-TextBody--xxxs.u-textLeft--all, .il-text, .ElementsWidget-prefix .R-TextHeading--xxs, .prduct-title-text, a.cart-item__name.h4.break, .product__title h1, h4.akkordeon-headline_big, .experten-headline, h3.card__heading.h5 a, .accordion__content, h3.accordion__title.inline-richtext.h4, .inhalt, .cares-desc, .tab-text-wrapper, .tab-text, .tab-small-headline, .cares-headline, .banner__text p, .icon-text, .gruende-fuer-section-subheading, .gruende-fuer-icon-text, .vorteile-abo-section-heading, .product-title, .headline-text, .content-text, .ab-modal-content p, a.cart-item__name.h4.break, .intro-text, .des-text1, .des-text4, .ds-headline, .vertraeglichkeit-text p, .text, .buy-headline, .rich-text__heading, .slide-headlinesmall, .tbb-headline, .product-headline, .ElementsWidget-prefix .R-TextHeading--xxs, a.cart-item__name.h4.break';

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.addedNodes.length > 0) {
        mutation.addedNodes.forEach(function (node) {
          if (node.matches(targetSelectors)) {
            manipulateElement(node);
          }
        });
      }
    });
  });

  var config = { childList: true, subtree: true };
  observer.observe(document.body, config);
}

document.addEventListener('DOMContentLoaded', function () {
  var targetElements = document.querySelectorAll('.cart-item__name, .vorteil-text, .product-subtext, .steckt-drin-small-headline, .page-content p, .ph-subheadline, .track123_order_info_detail_title, .content-text-second, .phasen-text, .benefit-amount, .fussnote-page.fussnote-index, h2.collapsible-content__heading.inline-richtext, h4.phasen-headline, em.R-TextBody.R-TextBody--xxxs.u-textLeft--all, .il-text, .ElementsWidget-prefix .R-TextHeading--xxs, .prduct-title-text, a.cart-item__name.h4.break, .product__title h1, h4.akkordeon-headline_big, .experten-headline, h3.card__heading.h5 a, .accordion__content, h3.accordion__title.inline-richtext.h4, .cares-desc, .tab-text, .inhalt, .tab-text-wrapper, .tab-small-headline, .cares-headline, .banner__text p, .icon-text, .gruende-fuer-section-subheading, .gruende-fuer-icon-text, .vorteile-abo-section-heading, .product-title, .headline-text, .content-text, .ab-modal-content p, a.cart-item__name.h4.break, .intro-text, .des-text1, .des-text4, .ds-headline, .vertraeglichkeit-text p, .text, .buy-headline, .rich-text__heading, .slide-headlinesmall, .tbb-headline, .product-headline, .ElementsWidget-prefix .R-TextHeading--xxs, a.cart-item__name.h4.break');
  if (targetElements.length > 0) {
    targetElements.forEach(function (element) {
      manipulateElement(element);
    });
  } else {
    startObserver();
  }
});

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const button = event.target.closest('button');
    if (!button) return;
    if (button.hasAttribute('disabled') || button.classList.contains('disabled')) return;

    const cartRoot = this.closest('cart-drawer-items') || this.closest('cart-items');
    if (cartRoot && cartRoot.dataset.qtyUpdating === 'true') return;

    const previousValue = this.input.value;
    if (button.name === 'plus') {
      this.input.stepUp();
    } else {
      this.input.stepDown();
    }

    if (previousValue === this.input.value) return;

    // Slidecart / cart page: one +/- click, then wait for Ajax refresh
    if (cartRoot && this.classList.contains('cart-quantity')) {
      cartRoot.dataset.qtyUpdating = 'true';
      cartRoot.classList.add('is-qty-updating');
      cartRoot.querySelectorAll('quantity-input.cart-quantity button').forEach((btn) => {
        btn.setAttribute('disabled', 'disabled');
      });
    }

    this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
    }
    const buttonPlus = this.querySelector(".quantity__button[name='plus']");
    if (!buttonPlus) return;

    let atMax = false;
    if (this.input.max !== undefined && this.input.max !== '') {
      atMax = value >= parseInt(this.input.max, 10);
    }

    buttonPlus.classList.toggle('disabled', atMax);
    if (atMax) {
      buttonPlus.setAttribute('disabled', 'disabled');
    } else {
      buttonPlus.removeAttribute('disabled');
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll('button:not(.localization-selector)').forEach((button) =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        document.querySelector('sticky-header.header-wrapper').classList.add('menu-open-ab');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
      document.querySelector('sticky-header.header-wrapper').classList.add('menu-open-ab');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    document.querySelector('sticky-header.header-wrapper').classList.remove('menu-open-ab');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
      document.querySelector('sticky-header.header-wrapper').classList.remove('menu-open-ab');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
      document.querySelector('sticky-header.header-wrapper').classList.add('menu-open-ab');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    console.log("Test1");
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked
        ? this.pause()
        : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (event.currentTarget.name === 'previous') {
      this.currentPage = (this.currentPage - 2 + this.sliderItemsToShow.length) % this.sliderItemsToShow.length + 1;
    } else if (event.currentTarget.name === 'next') {
      this.currentPage = this.currentPage % this.sliderItemsToShow.length + 1;
    }

    this.slideScrollPosition = (this.currentPage - 1) * this.sliderFirstItemNode.clientWidth;

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }


  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (
      !this.reducedMotion.matches &&
      !this.announcementBarArrowButtonWasClicked
    ) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    setTimeout(() => {
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
      (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
      this.updateSellingPlan();
    }
  }

  updateSellingPlan() {
    if (!document.querySelector("#subscriptionInterval")) return;
    const sellingPlanInterval = document.querySelector('variant-radios input[type="radio"]:checked').dataset.peroid;
    document.querySelector("#subscriptionInterval").innerHTML = sellingPlanInterval;
    if (document.querySelector("[name='buyoption']:checked").value.length) {
      const sellingPlanId = document.querySelector('variant-radios input[type="radio"]:checked').dataset.sellingPlan;
      document.querySelector('[name="selling_plan"]').value = sellingPlanId;
    } else {
      document.querySelector('[name="selling_plan"]').value = '';
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true)
    );

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    if (this.currentVariant.id === 44404268269869) {
      document.body.classList.add("first-variant");
      document.body.classList.remove("third-variant");
      document.body.classList.remove("second-variant");
    } else if (this.currentVariant.id === 44404268302637) {
      document.body.classList.add("second-variant");
      document.body.classList.remove("first-variant");
      document.body.classList.remove("third-variant");
    } else if (this.currentVariant.id === 44404268335405) {
      document.body.classList.add("third-variant");
      document.body.classList.remove("first-variant");
      document.body.classList.remove("second-variant");
    } else {
      document.body.classList.remove("first-variant");
      document.body.classList.remove("third-variant");
      document.body.classList.remove("second-variant");
    }

    const newUrl = new URL(window.location.href);
    newUrl.searchParams.set("variant", this.currentVariant.id);
    window.history.replaceState(
      {},
      "",
      newUrl.toString().replace(newUrl.origin, "")
    );
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`
    );
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }



  updateVariantStatuses() {
    const ausgewähltesRadio = document.querySelector('fieldset.product-form__input input[type=radio]:checked+label .product-form__variation-name');
    const mainContentElement = document.getElementById('MainContent');
    const variantRadioElements = document.querySelector('.no-js-hidden.ab-test-variant');
    var element = document.querySelector('.sub-info-wrapper');
    var elementSP = document.querySelector('.product-selling-plan');
    var elementVI = document.querySelector('.product-variant-id');
    if ((window.location.pathname.includes('/products/kijimea-k53-advance') || window.location.pathname.includes('/products/kijimea-k53-advance-a')) && ausgewähltesRadio && ausgewähltesRadio.innerText.trim() === 'Abo-Service') {
      element.classList.add('active');
      var regularPrice = document.querySelector('.price__container div.price__sale.price__abtest-new s.price-item.price-item--regular');
      if (regularPrice) {
        regularPrice.innerHTML = "79,90 €";
      }
      var saleBadge = document.querySelector('.price__container div.price__sale.price__abtest-new span.badge.price__badge-sale.color-accent-2');
      if (saleBadge) {
        saleBadge.innerHTML = "-6%";
      }
      var salePrice = document.querySelector('.price__container div.price__sale.price__abtest-new .inner-wrapper span.price-item.price-item--sale.price-item--last');
      if (salePrice) {
        salePrice.innerHTML = "74,90 € alle 84 Tage";
      }

      elementSP.setAttribute('value', '689349296476');
      elementVI.setAttribute('value', '44404268335405');
    } else if (window.location.pathname.includes('/products/kijimea-regularis-plus') && ausgewähltesRadio && ausgewähltesRadio.innerText.trim() === 'Abo-Service') {
      element.classList.add('active');
      var regularPrice = document.querySelector('.price__container div.price__sale.price__abtest-new s.price-item.price-item--regular');
      if (regularPrice) {
        regularPrice.innerHTML = "41,99 €";
      }
      var saleBadge = document.querySelector('.price__container div.price__sale.price__abtest-new span.badge.price__badge-sale.color-accent-2');
      if (saleBadge) {
        saleBadge.innerHTML = "-5%";
      }
      var salePrice = document.querySelector('.price__container div.price__sale.price__abtest-new .inner-wrapper span.price-item.price-item--sale.price-item--last');
      if (salePrice) {
        salePrice.innerHTML = "39,90 € alle 30 Tage";
      }

      elementSP.setAttribute('value', '689349067100');
      elementVI.setAttribute('value', '47621812322652');
    } else if (window.location.pathname.includes('/products/kijimea-reizdarm-pro') && ausgewähltesRadio && ausgewähltesRadio.innerText.trim() === 'Abo-Service') {
      element.classList.add('active');
      var regularPrice = document.querySelector('.price__container div.price__sale.price__abtest-new s.price-item.price-item--regular');
      if (regularPrice) {
        regularPrice.innerHTML = "89,90 €";
      }
      var saleBadge = document.querySelector('.price__container div.price__sale.price__abtest-new span.badge.price__badge-sale.color-accent-2');
      if (saleBadge) {
        saleBadge.innerHTML = "-5%";
      }
      var salePrice = document.querySelector('.price__container div.price__sale.price__abtest-new .inner-wrapper span.price-item.price-item--sale.price-item--last');
      if (salePrice) {
        salePrice.innerHTML = "84,90 € alle 42 Tage";
      }

      elementSP.setAttribute('value', '689420370268');
      elementVI.setAttribute('value', '44273690935597');
    } else {
      elementSP.setAttribute('value', '');
      elementVI.setAttribute('value', '');
    }
    if (ausgewähltesRadio && ausgewähltesRadio.innerText.includes('Starterpaket')) {
      mainContentElement.classList.add('28Tage');
      mainContentElement.classList.remove('84Tage');
    } else if (ausgewähltesRadio && ausgewähltesRadio.innerText.includes('Aufbaupaket')) {
      mainContentElement.classList.remove('28Tage');
      mainContentElement.classList.add('84Tage');
    } else {
      mainContentElement.classList.remove('28Tage');
      mainContentElement.classList.remove('84Tage');
    }
    if (ausgewähltesRadio && ausgewähltesRadio.innerText.trim() === '28 Kapseln') {
      variantRadioElements.classList.add('28Kapseln');
      variantRadioElements.classList.remove('56Kapseln');
    } else if (ausgewähltesRadio && ausgewähltesRadio.innerText.trim() === '56 Kapseln') {
      variantRadioElements.classList.add('56Kapseln');
      variantRadioElements.classList.remove('28Kapseln');
    } else {
      variantRadioElements.classList.remove('56Kapseln');
      variantRadioElements.classList.remove('28Kapseln');
    }
    if (ausgewähltesRadio && ausgewähltesRadio.innerText.trim() === '525g') {
      mainContentElement.classList.add('525g');
    } else {
      mainContentElement.classList.remove('525g');
    }
    if (ausgewähltesRadio && ausgewähltesRadio.innerText.trim() === '225g') {
      mainContentElement.classList.add('225gnew');
    } else {
      mainContentElement.classList.remove('225gnew');
    }
    if (ausgewähltesRadio && ausgewähltesRadio.innerText.trim() === '450 g') {
      mainContentElement.classList.add('450g');
    } else {
      mainContentElement.classList.remove('450g');
    }
    if (ausgewähltesRadio && ausgewähltesRadio.innerText.trim() === '225 g') {
      mainContentElement.classList.add('225g');
    } else {
      mainContentElement.classList.remove('225g');
    }
    if (ausgewähltesRadio && ausgewähltesRadio.innerText.trim() === '20 Brausetabletten') {
      mainContentElement.classList.add('20Brausetabletten');
    } else {
      mainContentElement.classList.remove('20Brausetabletten');
    }
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
    const sellingPlan = document.querySelector('[name="selling_plan"]').value;
    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&selling_plan=${sellingPlan}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        const volumePricingSource = html.getElementById(
          `Volume-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const variantSource = html.querySelector(
          `#variant-radios-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section} fieldset`
        );
        const variantDestination = document.querySelector(`#variant-radios-${this.dataset.section} fieldset`);

        const variantSourceLast = html.querySelector(
          `#variant-radios-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section} fieldset.abtest`
        );
        const variantDestinationLast = document.querySelector(`#variant-radios-${this.dataset.section} fieldset.abtest`);

        const subscriptionDiscountSource = html.querySelector(
          `.subscription-wrapper  > div:first-child .sub-offer`
        );
        const subscriptionDiscountDestination = document.querySelector(`.subscription-wrapper > div:first-child .sub-offer`);


        const taxHintSource = html.querySelector(
          `product-info >.product__tax`
        );
        const taxHintDestinations = document.querySelectorAll(`product-info >.product__tax`);


        const singleDiscountSource = html.querySelector(
          `.subscription-wrapper  > div:last-child .sub-offer`
        );
        const singleDiscountDestination = document.querySelector(`.subscription-wrapper > div:last-child .sub-offer`);


        const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
        const pricePerItemSource = html.getElementById(`Price-Per-Item-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);

        const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);
        const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);
        const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);

        if (volumeNote) volumeNote.classList.remove('hidden');
        if (volumePricingDestination) volumePricingDestination.classList.remove('hidden');
        if (qtyRules) qtyRules.classList.remove('hidden');

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (variantSource && variantDestination) variantDestination.innerHTML = variantSource.innerHTML;
        if (variantSourceLast && variantDestinationLast) variantDestinationLast.innerHTML = variantSourceLast.innerHTML;

        if (subscriptionDiscountSource && subscriptionDiscountDestination) subscriptionDiscountDestination.innerHTML = subscriptionDiscountSource.innerHTML;
        if (singleDiscountSource && singleDiscountDestination) singleDiscountDestination.innerHTML = singleDiscountSource.innerHTML;

        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('hidden', skuSource.classList.contains('hidden'));
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (taxHintSource && taxHintDestinations) taxHintDestinations.forEach(taxHintDestination => taxHintDestination.innerHTML = taxHintSource.innerHTML);

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle('hidden', pricePerItemSource.classList.contains('hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('hidden');

        if (inventoryDestination)
          inventoryDestination.classList.toggle('hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
          window.variantStrings.soldOut
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
    const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);
    const volumeTable = document.getElementById(`Volume-${this.dataset.section}`);
    const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('hidden');
    if (inventory) inventory.classList.add('hidden');
    if (sku) sku.classList.add('hidden');
    if (pricePerItem) pricePerItem.classList.add('hidden');
    if (volumeNote) volumeNote.classList.add('hidden');
    if (volumeTable) volumeTable.classList.add('hidden');
    if (qtyRules) qtyRules.classList.add('hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);



class SubscriptionSelector extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll("input[type='radio']").forEach((radio) => {
      radio.addEventListener('change', this.onChange.bind(this));
    });
    addEventListener("DOMContentLoaded", this.initSellinPlan.bind(this));
  }

  onChange(e) {
    const sellingPlanId = document.querySelector('variant-radios input[type="radio"]:checked').dataset.sellingPlan;
    document.querySelector('[name="selling_plan"]').value = (e.currentTarget.value) ? sellingPlanId : "";
    document.querySelector("variant-radios").onVariantChange();
    if (!e.target.value) {
      this.querySelector(".buying-box-info-box").classList.replace("subscription", "singlebuy");
    } else {
      this.querySelector(".buying-box-info-box").classList.replace("singlebuy", "subscription");
    }
  }

  initSellinPlan() {
    const sellingPlanId = document.querySelector('variant-radios input[type="radio"]:checked').dataset.sellingPlan;
    const subscriptionInterval = document.querySelector('variant-radios input[type="radio"]:checked').dataset.peroid;
    document.querySelector('[name="selling_plan"]').value = sellingPlanId;
    document.querySelector('#subscriptionInterval').innerHTML = subscriptionInterval;

    document.querySelector("variant-radios").onVariantChange();
  }


}

customElements.define('subscription-selector', SubscriptionSelector);



class AccordionWrapper extends HTMLElement {
  constructor() {
    super();
    var index = 1;
    this.openFirstAccordion();
    this.querySelectorAll("details").forEach((accordion) => {
      accordion.addEventListener("toggle", (e) => {
        if (accordion.open) {
          Array.from(this.querySelectorAll("details[open]")).filter(item => item != accordion).forEach(item => item.removeAttribute("open"));
          if (index != 1) {
            this.updateAnchors(accordion);
          }
          index++;
        }
      });
    });
  }

  openFirstAccordion() {
    const firstAccordion = this.querySelector("details");
    firstAccordion.setAttribute("open", true);
  }

  updateAnchors(accordion) {
    const anchorId = 'akkordeon-anchor';
    this.querySelectorAll('.accordion').forEach(item => item.removeAttribute('id'));
    accordion.classList.add(anchorId);
    accordion.scrollIntoView({ behavior: 'smooth' });
  }
}

customElements.define('accordion-wrapper', AccordionWrapper);

document.addEventListener('DOMContentLoaded', function () {
  setTimeout(function () {
    var firstLogo = document.querySelector('a.R-ReviewsioLogo.R-ReviewsioLogo--sm');
    if (firstLogo) {
      firstLogo.removeAttribute('href');
    }

    var secondLogo = document.querySelector('a.u-displayInlineBlock.footer__reviewsLogo-container');
    if (secondLogo) {
      secondLogo.removeAttribute('href');
    }
  }, 5000);
});


class StickyATC extends HTMLElement {
  constructor() {
    super();
    const button = this.querySelector(".product-form__submit");

    const quantityInput = this.querySelector("[name='quantity']");
    button.addEventListener("click", () => {
      document.querySelector("product-form .product-form__submit").click();
    });
    quantityInput.addEventListener("change", () => document.querySelector(".product-form-wrapper .product-form__quantity .quantity__input").value = quantityInput.value);

    subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
      this.querySelector(".price-text").innerHTML = data.html.querySelector(".price-item.price-item--sale.price-item--last").innerText.trim();
      this.querySelector(".mwst-text").innerHTML = data.html.querySelector(".product__tax.caption.rte").innerText.trim();
    })
  }
}

customElements.define('sticky-atc', StickyATC);


document.addEventListener('DOMContentLoaded', function () {
  var now = new Date();
  var expires = new Date();
  expires.setTime(now.getTime() + 24 * 60 * 60 * 1000);
  if (window.location.search.includes("kliquidf")) {
    document.cookie = "LiquidFree=true; expires=" + expires.toUTCString() + "; path=/";
  } else if (window.location.href.includes("utm_medium=postwurf")) {
    document.cookie = "ImmunFree=true; expires=" + expires.toUTCString() + "; path=/";
  } else if (window.location.search.includes("k53f")) {
    document.cookie = "K53Free=true; expires=" + expires.toUTCString() + "; path=/";
  } else if (window.location.search.includes("k53gift")) {
    document.cookie = "K53FreeNew=true; expires=" + expires.toUTCString() + "; path=/";
  }
});


document.addEventListener('DOMContentLoaded', function () {
  var ratingSnippetDiv = document.getElementById('ratingSnippet');
  var aElement = document.createElement('a');
  aElement.href = '#ReviewsWidget';
  ratingSnippetDiv?.appendChild(aElement);
});



/*preselect 2nd variant*/
/*
document.addEventListener('DOMContentLoaded', function () {
  if (window.location.href.includes("kijimea-reizdarm-pro") ||
      window.location.href.includes("kijimea-k53-advance") ||
      window.location.href.includes("kijimea-floracare")) {
       
    const labels = document.querySelectorAll('label[for="template--24077476462940__main-1-1"]'); 

    labels.forEach(label => {
      label.click();
    });
  }
});
*/

document.addEventListener('DOMContentLoaded', function () {
  if (window.location.href.includes("kijimea.at") &&
      (window.location.href.includes("kijimea-reizdarm-pro") ||
       window.location.href.includes("kijimea-k53-advance") ||
       window.location.href.includes("kijimea-k53-advance-a") ||
       window.location.href.includes("kijimea-magen") ||
       window.location.href.includes("kijimea-synpro-20") ||
       window.location.href.includes("kijimea-derma") ||
       window.location.href.includes("kijimea-life") ||
       window.location.href.includes("kijimea-k53") ||
       window.location.href.includes("kijimea-floracare"))) {
       
    const labels = document.querySelectorAll('label[for="template--23416142299484__main-1-1"]');

    labels.forEach(label => {
      label.click();
    });
  }
});